import React from "react";
import { Layout } from "antd";
import config from "../../config.json";
import "./BaseFooter.scss";

const { Footer } = Layout;

function BaseFooter() {
  return (
    <Footer className="footer">
      <span>
        {config.footer.text}
        {/*<a className="mail" href="mailto:techsupport@lnconsult.at?Subject=Support">*/}
        {/*  {config.footer.mailString}*/}
        {/*</a>*/}
      </span>
    </Footer>
  );
}

export default BaseFooter;
